function safeParseNumber(number: any) {
  return Number(number) || 0;
}

function sortAlphabetically(elements: string[]) {
  return elements.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
}

function getBoxImageProxyUrl(imageUrl: string) {
  const boxRegexPattern = new RegExp('^https?://on.box.com');
  const isBoxUrl = boxRegexPattern.test(imageUrl);
  const proxy = import.meta.env.VITE_APP_boxProxy;

  if (!isBoxUrl || !proxy) {
    return imageUrl;
  }

  return imageUrl.replace(boxRegexPattern, proxy);
}

export { getBoxImageProxyUrl, safeParseNumber, sortAlphabetically };
